import { render } from "./WaitPaymentDialog.vue?vue&type=template&id=d7d2bd0c&ts=true"
import script from "./WaitPaymentDialog.vue?vue&type=script&lang=ts"
export * from "./WaitPaymentDialog.vue?vue&type=script&lang=ts"

import "./WaitPaymentDialog.vue?vue&type=style&index=0&id=d7d2bd0c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QDialog from 'quasar/src/components/dialog/QDialog.js';
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSpinnerClock from 'quasar/src/components/spinner/QSpinnerClock.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QDialog,QCard,QCardSection,QBtn,QSpinnerClock,QCardActions});
